export default __webpack_public_path__ + "static/media/flightIcon.a0b72068.svg";